<script>
    import WPNSelector from "../Misc/WPNSelector.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import {
        getPersonWithRoleInItem,
        setRoleForPersonUuidInItem,
        setWorkPersonnelValueForKey,
        personnelDataForWorkItem,
    } from "../../scripts/wpn2DB.js";

    export let selectedItem = null;
    let mgrIndex;
    let mgr;
    let allPersons = $dbData.all["Person"].map((x) => {
        return { title: x["name"], value: x["uuid"] };
    });
    let personnelData;

    $: personnelData = personnelDataForWorkItem(selectedItem, $dbData.all);
    $: mgrIndex =
        selectedItem != undefined
            ? (selectedItem.personnel ?? []).findIndex(
                  (x) => x.role == "Manager"
              )
            : -1;
    $: mgr = getPersonWithRoleInItem(selectedItem, "Manager", $dbData.all) ?? { name: "" };

    function addNewPerson() {
        var existingItem = { ...selectedItem };
        const existingPersonnel = existingItem.personnel ?? [];
        const currentTime = new Date().getTime();
        // Person-Effort: {"person_uuid": "string?", "role": "string?", "statement": string?, "start": int?, reg_dur: int, ot_dur: string}
        const newPersonnel = [
            ...existingPersonnel,
            {
                person_uuid: $dbData.user_item["uuid"],
                role: "",
                work_statement: "",
                start: currentTime,
                reg_dur: 0,
                ot_dur: 0,
            },
        ];
        existingItem.personnel = [...newPersonnel];
        selectedItem = { ...existingItem };
        console.log("Added Person: ", selectedItem);
        return;
    }

    function removePerson(event) {
        const index = event.currentTarget.id;
        var existingItem = { ...selectedItem };
        var existingPersonnel = existingItem.personnel ?? [];
        if (existingPersonnel.length > index) {
            existingPersonnel.splice(index, 1);
            existingItem.personnel = [...existingPersonnel];
            selectedItem = { ...existingItem };
            console.log("Removed Person: ", selectedItem);
        }
        return;
    }

    function changedPersonValue(event, key, index) {
        var value;
        // var index;
        if (key == "person_uuid") {
            value = event.detail.value;
            // index = allPersons.findIndex((x) => x.person_uuid == value);
        } else if (["start", "reg_dur", "ot_dur"].includes(key)) {
            value = Number(event.currentTarget.value);
            // index = event.currentTarget.id;
        } else {
            value = event.currentTarget.value;
            // index = event.currentTarget.id;
        }
        var existingItem = { ...selectedItem };
        var existingPersonnel = existingItem.personnel ?? [];
        if (existingPersonnel.length > index) {
            // Person-Effort: {"person_uuid": "string?", "role": "string?", "statement": string?, "start": int?, reg_dur: int?, ot_dur: int?}
            selectedItem = setWorkPersonnelValueForKey(
                key,
                value,
                index,
                existingItem
            );
            console.log("Changed Person Value: ", index, selectedItem);
        }
        return;
    }

    function updateManager(event) {
        // TODO: Continue here: Rename, define manager, creator & reporter in schema & don't show in table, remove role?
        // TODO: Document Issue UI
        var mgrUuid = event.detail.value;
        selectedItem = setRoleForPersonUuidInItem(selectedItem, "Manager", mgrUuid);
        console.log("Changed Manager: ", selectedItem);
    }
</script>

<div class="edit-container">
    <div class="edit-section-title">Personnel</div>
    <div class="edit-col" id="priority-col">
        <label class="edit-label" for="selManager">Manager</label>
        <WPNSelector
            selectorOptions={allPersons}
            selectorName="selManager"
            selected={mgr["uuid"]}
            on:selector-changed={updateManager}
        />
    </div>
    {#if personnelData.length == 0}
        <p class="edit-related-statement">
            {"There are no personnel listed for " + selectedItem.name ?? selectedItem.wpn2_type + "."}
        </p>
    {:else}
        <table class="general-table">
            <thead>
                <tr>
                    {#each personnelData[0] as x}
                        {#if ["name", "work_statement", "start", "reg_dur", "ot_dur"].includes(x.key)}
                            <th scope="col">{x.title}</th>
                        {:else}
                            <th scope="col">{" "}</th>
                        {/if}
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each personnelData as person, index}
                    <tr>
                        {#each person as x}
                            {#if x.key == "name"}
                                <td>
                                    <WPNSelector
                                        selectorOptions={allPersons}
                                        selectorName="selPersonEffort"
                                        selected={x.value}
                                        on:selector-changed={(event) =>
                                            changedPersonValue(
                                                event,
                                                "person_uuid",
                                                index
                                            )}
                                    />
                                </td>
                                <!-- <td>{x.value}</td> -->
                            {:else if x.key == "work_statement"}
                                <input
                                    class="personnel-input"
                                    placeholder="Description of work performed"
                                    type="text"
                                    id={index}
                                    value={x.value}
                                    on:change|preventDefault={(event) =>
                                        changedPersonValue(event, x.key, index)}
                                />
                            {:else if x.key == "start"}
                                <td>{x.value}</td>
                            {:else if x.key == "reg_dur"}
                                <td>
                                    <input
                                        class="personnel-input"
                                        type="number"
                                        min="0"
                                        step="0.25"
                                        id={index}
                                        value={x.value}
                                        on:change|preventDefault={(event) =>
                                            changedPersonValue(
                                                event,
                                                x.key,
                                                index
                                            )}
                                    />
                                </td>
                            {:else if x.key == "otHours"}
                                <td>
                                    <input
                                        class="personnel-input"
                                        type="number"
                                        min="0"
                                        step="0.25"
                                        id={index}
                                        value={x.value}
                                        on:change|preventDefault={(event) =>
                                            changedPersonValue(
                                                event,
                                                x.key,
                                                index
                                            )}
                                    />
                                </td>
                            {/if}
                        {/each}
                        {#if mgrIndex != index}
                            <td>
                                <button
                                    class="trash-can-button"
                                    id={index}
                                    on:click|preventDefault={(event) =>
                                        removePerson(event)}
                                >
                                    &#x1F5D1
                                </button>
                            </td>
                        {/if}
                    </tr>
                {/each}
            </tbody>
        </table>
    {/if}
    <div class="add-button-view">
        <button class="edit-add-button" on:click={addNewPerson}>
            Add Person
        </button>
    </div>
</div>

<style>
    .personnel-input {
        margin: 0;
    }
</style>
